import request from '@/utils/request';
import { set, get, clear as clearLocal } from '@/utils/local';

const APP_CONFIG_STORAGE_KEY = 'appConfiguration';

export async function fetchApplicationConfiguration(force = false) {
    if (!force) {
        const cachedConfiguration = get(APP_CONFIG_STORAGE_KEY);
        if (cachedConfiguration) {
            return cachedConfiguration;
        }
    }

    const configuration = await request({
        url: '/api/abp/application-configuration',
        method: 'get'
    });

    if (configuration) {
        set(APP_CONFIG_STORAGE_KEY, configuration);
    }

    return configuration;
}

export function getApplicationConfiguration() {
    return get(APP_CONFIG_STORAGE_KEY);
}

export function clearApplicationConfiguration() {
    clearLocal(APP_CONFIG_STORAGE_KEY);
}

export function getFeautureList() {
    const configuration = getApplicationConfiguration();
    if (configuration && configuration.features && configuration.features.values) {
        return configuration.features.values;
    }
    return {};
}

export { APP_CONFIG_STORAGE_KEY };
